
import returnIcon from "../../../assets/img/modals/return.svg";
import customizeModalDomainsIcon from "../../../assets/img/modals/customize-modal-domains-banner.svg";
import style from "../../../assets/css/project.css";
import { useEffect, useState } from "react";
import { CustomizeDomainModal } from "../customize-page";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Loader, { hideLoader, showLoader } from "../../loader";
import { useDispatch, useSelector } from "react-redux";
import { audiencePosts as eventTracking} from "../../../services/postRequests/audience";
import customizeDomainsIcon from "../../../assets/img/modals/customize-modal-domains-icon.svg"
import { audiencePosts as apiService  } from "../../../services/postRequests/audience";
import { apiUrl } from "../../../utils/url";
const DomainsCustomize = ({ handleSubmit, error, settings, slug }) => {

    const dispatch = useDispatch()
    const value = useSelector(state => state?.customizeDomainsReducer);
    const location = useLocation()
    const history = useHistory()
    const [show, setshow] = useState(false);
    const { basePath } = useSelector(state => state?.slugReducer);
    const isPro = useSelector(state => state?.proReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null });
    const [isdomainConnect, setisdomainConnect] = useState(true);
    const [showButton, setshowButton] = useState(false);


    useEffect(() => {
        if (location.pathname == basePath + "/page-editor/customizePageModal/customizePageDomains/customDomainModal") {
            setshow(true)
        }
        else {
            setshow(false)
        }
    }, [location.pathname]);

    const setParams = (paramName, tabName) => {
        showLoader()

        if (!isPro && !newUser) {
            history.push(`${basePath}/page-editor`)
            dispatch({ type: "SET_UPGRADE_MODAL", payload: { isPro: false, open: true } })
            hideLoader()
            return
        }

        history.push({
            state: { showCustomizeParent: true }
        })
        setTimeout(() => {
            hideLoader()
            history.push({
                pathname: `${basePath}/page-editor/${paramName}/${tabName}`,
                state: { showCustomizeParent: true }
            })

        }, 300);
    }
    const eventTrack = (event) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("name", "Custom domain clicked");
        formdata.append("project", slug);

        const api = apiUrl + `/event-track`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders
        }
        eventTracking(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })
        setParams("customizePageModal/customizePageDomains", "customDomainModal")
    }
    const disconnectDomain = (id) => {
        showLoader();
        const api = apiUrl + "/project/deletedomain/" + id;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        apiService(api, hideLoader, setOptions).then(() => {
            setisdomainConnect(false)
            hideLoader();
            dispatch({ type: 'RESET_CUSTOMIZE_DOMAINS' })
        }).catch((err) => {
            
// console.log(err);
        })

    }
    return (
        <div class="tab-pane fade customize-page-main active show" id="customizePageDomains" role="tabpanel" aria-labelledby="social-tab">
            <h4>Domains</h4>

            <section>
                <div class="form-group">
                    <img src={customizeModalDomainsIcon} width="100%" alt="" />
                </div>

                <div class="form-group mt-3">
                    <div class="custom-domain-input-group">
                        <p class="mb-0">Connect a custom domain to your page</p>
                        <button type="button" title={value?.domain}
                            onClick={eventTrack}
                            class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center customDomainModal"
                            disabled={value?.domain ?  true : false}
                        >
                            <b class="me-2"><small>{value?.domain ? "Connected Domain" : "Connect Domain"}</small></b>
                            <small class="bg-primary-dark btn-sm text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                <img src={returnIcon} alt="" />
                            </small>
                        </button>
                    </div>
                </div>
                {isdomainConnect && <>{value?.domain ?
                    <div class="form-group mt-3 ">
                        <div class="custom-domain-input-group domain-enabled" >
                            <div className="d-flex justify-content-start ">
                                <img src={customizeDomainsIcon} width="32px" alt="" />
                                <p class="mb-0 p-2 ms-1">{value?.domain}</p>
                            </div>
                            <button type="button" onClick={() => disconnectDomain(value?.project_id)}
                                class="btn btn-grey btn-semi-rounded d-flex align-items-center justify-content-center customDomainModal">
                                <b class="me-2"><small> Disconnect</small></b>
                            </button>
                        </div>
                    </div>
                    : ""
                } </>}
                <div>
             </div>




            </section>
            <CustomizeDomainModal show={show} handleSubmit={handleSubmit} error={error} setshow={setshow} />
        </div>
    )
}
export default DomainsCustomize